import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "review-box-modal__heading-container" }
const _hoisted_2 = { class: "review-box-list-item__text-content" }
const _hoisted_3 = { class: "review-box-list-item__title" }
const _hoisted_4 = { class: "review-box-list-item__text" }
const _hoisted_5 = { class: "review-box-modal__details-section" }
const _hoisted_6 = { class: "review-box-modal__details-section--review" }

import { computed } from 'vue';
import CustomerReviewsBar from '@lmt-rpb/CustomerReviewsBar/CustomerReviewsBar.vue';
import { RATING_MAX_VALUE } from '@global-js/constants';
import ReviewerInfo from './ReviewerInfo.vue';
import type { ReviewType } from '@/interfaces/review-types';
import RatingBox from './RatingBox.vue';
import { numberFormat } from '@/js/utils/numberUtils';

type Conclusion = {
	name: string,
	conclusion: string | null;
	rating: number;
};

interface Props {
    review: ReviewType
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewModalContent',
  props: {
    review: {}
  },
  setup(__props: any) {

const props = __props;

const rating = computed(() => `${numberFormat(props.review.RatingOverallValue)}/${RATING_MAX_VALUE}`);

const conclusions = computed((): Conclusion[] => {
	const { Reviews, Conclusion, RatingOverallValue } = props.review;
	const totalConclusion = { name: 'Gesamt', conclusion: Conclusion, rating: RatingOverallValue };
	const reviewConclusions = Object.entries(Reviews)
		.map(([name, { Conclusion: conclusion = '', Value: rating }]) => (
			{ name, conclusion, rating: rating ?? 0 }
		));
	return [totalConclusion, ...reviewConclusions];
});

const recommend = computed((): string => {
	const { Recommendation } = props.review;
	return Recommendation ? 'Ja' : 'Nein';
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RatingBox, {
        class: "review-box-modal__rating-box",
        rating: rating.value
      }, null, 8 /* PROPS */, ["rating"]),
      _createVNode(ReviewerInfo, {
        review: _ctx.review,
        size: "sm"
      }, null, 8 /* PROPS */, ["review"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.review.Headline), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.review.Conclusion), 1 /* TEXT */)
    ]),
    _createElementVNode("dt", {
      class: _normalizeClass([
			'review-box-modal__recommend',
			_ctx.review.Recommendation ? 'recommend' : null
		])
    }, " Weiterempfehlung: " + _toDisplayString(recommend.value), 3 /* TEXT, CLASS */),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conclusions.value, (conclusion) => {
        return (_openBlock(), _createElementBlock("div", {
          key: conclusion.name,
          class: "review-box-modal__details-section--item"
        }, [
          _createVNode(CustomerReviewsBar, {
            value: conclusion.rating,
            "max-value": 6,
            title: conclusion.name,
            rating: _unref(numberFormat)(conclusion.rating),
            class: "review-box-modal__details-section--rating"
          }, null, 8 /* PROPS */, ["value", "title", "rating"]),
          _createElementVNode("dd", _hoisted_6, _toDisplayString(conclusion.conclusion), 1 /* TEXT */)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})